import React, { useEffect, useState } from "react";
import DateEnableSwitch from "../molecules/dateSelector/DateEnableSwitch";
import DateSelector from "../molecules/dateSelector/DateSelector";
import FromToDatePickers from "../molecules/dateSelector/FromToDatePickers";
import classes from "./ProcessDateFilter.module.scss";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userState } from "../../../states/userState";
import { User } from "../../../types";
import { set } from "date-fns";
import { endDatePtList, endDatePvList } from "../../../commons/endDate";
import { setUserToLocalStorage } from "../../../lib/localStorageManager";

const ProcessDateFilter = () => {
  const [endDateList, setEndDateList] = useState<
    { id: string; name: string }[]
  >([]);
  const [fieldCode, setFieldCode] = useState("");
  const user = useRecoilValue<User>(userState);
  const setUser = useSetRecoilState(userState);
  const [checked, setChecked] = useState(user.filters.fromDate !== "");
  const getEndOfMonth = (date: Date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  };
  const getStartOfMonth = (date: Date) => {
    return new Date(date.getFullYear(), date.getMonth() - 0, 1);
  };
  const today = new Date();
  const initialStartDate =
    !user.filters.fromDate || user.filters.fromDate === ""
      ? getStartOfMonth(today)
      : new Date(user.filters.fromDate);
  const initialEndDate =
    !user.filters.toDate || user.filters.toDate === ""
      ? getEndOfMonth(today)
      : new Date(user.filters.toDate);
  console.log("Date", initialEndDate, initialStartDate);
  const [fromDate, setFromdate] = useState<Date | null>(initialStartDate), //日付From
    [toDate, setTodate] = useState<Date | null>(initialEndDate); //日付To
  useEffect(() => {
    if (checked == true) {
      setFromdate(initialStartDate);
      setTodate(initialEndDate);
    }
  }, [checked]);
  const handleChange = (value: string) => {
    setUser((prevUser: User) => {
      const updatedUser = {
        ...prevUser,
        filters: {
          ...prevUser.filters,
          dateField: value,
        },
      };
      setUserToLocalStorage(updatedUser);
      return updatedUser;
    });
  };
  useEffect(() => {
    if (
      user.viewId === 0 ||
      user.viewId === 50111 ||
      user.viewId === 5253 ||
      user.viewId === 54
    ) {
      setEndDateList(endDatePtList);
    } else {
      setEndDateList(endDatePvList);
    }
  }, [user.viewId]);
  return (
    <div className={classes.container}>
      <div className={classes.selectGroup}>
        <div className={classes.switch}>
          <DateEnableSwitch checked={checked} setChecked={setChecked} />
        </div>
        <div className={classes.dateSelector}>
          <DateSelector
            label={""}
            disabled={!checked}
            value={user.filters.dateField}
            options={endDateList}
            select={handleChange}
            required={true}
          />
        </div>
      </div>
      <div className={classes.dateGroup}>
        <div className={classes.datePicker}>
          <FromToDatePickers
            disabled={!checked}
            setFromdate={setFromdate}
            setTodate={setTodate}
            fromDate={fromDate}
            toDate={toDate}
            mode="flex"
            label={""}
          />
        </div>
      </div>
    </div>
  );
};

export default ProcessDateFilter;
